import axios from 'axios';
import React, { Fragment, useEffect, useState, useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';
import { IoMdArrowRoundBack } from "react-icons/io";
import { useDispatch, useSelector } from 'react-redux';
import { addItem, increaseQuantity, decreaseQuantity } from '../redux/cart';
import { FaStar, FaRegStar, FaStarHalfAlt } from 'react-icons/fa';
import { ToastContainer, Zoom, toast } from 'react-toastify';

function ProdByBrand() {
    const { brand } = useParams();
    const [productList, setProductList] = useState([]);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const cartItems = useSelector(state => state.cart.items || []);

    const API_URL = process.env.REACT_APP_API_URL;

    const handleFetchProducts = async () => {
        try {
            const response = await axios.get(`${API_URL}/products-by-brand/${brand}`);
            setProductList(response.data || []);
        } catch (err) {
            console.error("Error fetching products:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleFetchProducts();
    }, [brand]); // Ensures component updates when brand changes

    const toastConfig = {
        autoClose: 500,
        hideProgressBar: true,
        transition: Zoom,
        icon: false,
        closeButton: false,
        style: {
            width: '420px',
            border: '1px solid #bbbbbb',
            boxShadow: '0 0 21px #ed3237',
            textAlign: 'center',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#ed3237',
            fontSize: '16px'
        }
    };

    const handleAddToCart = useCallback((product) => {
        dispatch(addItem(product));
        toast.success('Item added to cart', toastConfig);
    }, [dispatch]);

    const handleInc = useCallback((id) => { dispatch(increaseQuantity(id)); }, [dispatch]);
    const handleDec = useCallback((id) => { dispatch(decreaseQuantity(id)); }, [dispatch]);

    return (
        <Fragment>
            <div className="container-fluid m-t25">
                <div className="row">
                    <div className="col-12 cat-strip border shadow-sm">
                        <div>
                            <button onClick={() => window.history.back()} aria-label="Go Back">
                                <IoMdArrowRoundBack />
                            </button>
                            <label>{brand.toUpperCase()}</label>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {loading ? (
                        <div className="loading-spinner">
                            <div className="spinner-border text-danger" role="status">
                                <span className="visually-hidden">Loading products...</span>
                            </div>
                        </div>
                    ) : (
                        productList.length > 0 ? (
                            productList.map((item, index) => {
                                const original = Number(item.originalPrice || item.price || 0);
                                const price = Number(item.price || 0);
                                const hasDiscount = original > price && original > 0;
                                const discountPct = hasDiscount ? Math.round(((original - price) / original) * 100) : 0;
                                const ratingVal = Number(item.rating || 0);
                                const stars = [];
                                for (let i = 1; i <= 5; i++) {
                                    if (ratingVal >= i) stars.push(<FaStar key={i} className='text-warning' />); else if (ratingVal >= i - 0.5) stars.push(<FaStarHalfAlt key={i} className='text-warning' />); else stars.push(<FaRegStar key={i} className='text-warning' />);
                                }
                                const cartEntry = cartItems.find(ci => ci._id === item._id || ci.name === item.name);
                                const inCart = !!cartEntry;
                                return (
                                    <div className="col-lg-2 col-md-3 col-sm-4 col-6 prod-list border text-center position-relative" key={item._id || index}>
                                        <Link to={`/product/${item.name}`} className='d-block w-100 position-relative' aria-label={`View product ${item.name}`}>
                                            {hasDiscount && (
                                                <span className='discount-badge' aria-label={`${discountPct}% discount`}>{discountPct}%</span>
                                            )}
                                            <img src={`${API_URL}/${item.image1}`} alt={item.name} className="w-100" />
                                            <label>{item.name.toUpperCase()}</label>
                                        </Link>
                                        <div className='d-flex justify-content-center align-items-center gap-1 mb-1' style={{ minHeight: '20px' }}>
                                            {stars}
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center mb-1 w-100' style={{fontSize:'13px',textAlign:'left'}}>
                                            <div className='d-flex align-items-center flex-wrap'>
                                                <strong className='text-danger me-1' style={{fontSize:'15px'}}>₹{price}</strong>
                                                {hasDiscount && <span className='text-muted text-decoration-line-through' style={{ fontSize: '12px' }}>₹{original}</span>}
                                            </div>
                                            {item.quantity && item.unit ? (
                                                <span className='text-muted small'>{item.quantity}{item.unit}</span>
                                            ) : <span className='invisible small'>.</span>}
                                        </div>
                                        {!inCart ? (
                                            <button onClick={() => handleAddToCart(item)}>ADD TO CART</button>
                                        ) : (
                                            <div className='qty-bar'>
                                                <button type='button' aria-label='Decrease quantity' onClick={() => handleDec(cartEntry._id)}>-</button>
                                                <span className='qty-mid'>{cartEntry.quantity}</span>
                                                <button type='button' aria-label='Increase quantity' onClick={() => handleInc(cartEntry._id)}>+</button>
                                            </div>
                                        )}
                                    </div>
                                );
                            })
                        ) : (
                            <p className="text-center">No products found for this brand.</p>
                        )
                    )}
                </div>
            </div>
            <ToastContainer />
        </Fragment>
    );
}

export default ProdByBrand;
